// @ts-nocheck
import { createTheme, alpha } from "@mui/material/styles";
import { DateConfig } from "./Constants";

const defaultTheme = createTheme({});

export const theme = customizeComponents({
  palette: {
    primary: {
      main: "#177EB9",
      "main-50": "#E7EEFF",
      "main-100": "#D0DDFF",
      "main-200": "#B0C6FF",
      "main-300": "#89A9FE",
      "main-400": "#628DFE",
      "main-500": "#1354FE",
      "main-600": "#1046D4",
      "main-700": "#0D38A9",
      "main-800": "#0A2A7F",
      "main-900": "#061C55",
    },
    neutral: {
      50: "#F9FAFB",
      100: "#F3F4F6",
      200: "#E5E7EB",
      300: "#D1D5DB",
      400: "#9CA3AF",
      500: "#6B7280",
      600: "#4B5563",
      700: "#374151",
      800: "#1F2937",
      900: "#111827",
    },
    success: {
      50: "#F0FDF4",
      100: "#DCFCE7",
      200: "#BBF7D0",
      300: "#86EFAC",
      400: "#4ADE80",
      500: "#22C55E",
      600: "#16A34A",
      700: "#15803D",
      800: "#166534",
      900: "#14532D",
    },
    warning: {
      50: "#FFFBEB",
      100: "#FEF3C7",
      200: "#FDE68A",
      300: "#FCD34D",
      400: "#FBBF24",
      500: "#F59E0B",
      600: "#D97706",
      700: "#B45309",
      800: "#92400E",
      900: "#78350F",
    },
    destructive: {
      50: "#FEF2F2",
      100: "#FEE2E2",
      200: "#FECACA",
      300: "#FCA5A5",
      400: "#F87171",
      500: "#EF4444",
      600: "#DC2626",
      700: "#B91C1C",
      800: "#991B1B",
      900: "#7F1D1D",
    },
    secondary: {
      main: "#161B2E",
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 640,
      md: 768,
      lg: 1024,
      xl: 1280,
      "2xl": 1536,
    },
  },
  typography: {
    // fontFamily: ["Inter", "sans-serif"].join(),
    fontFamily: [
      "'Inter'",
      "sans-serif",
      "Segoe UI",
      "-apple-system",
      "BlinkMacSystemFont",
      "Roboto",
      "Oxygen",
      "Ubuntu",
      "Cantarell",
      "Fira Sans",
      "Droid Sans",
      "Helvetica Neue",
      "sans-serif",
    ].join(),
    fontSize: 12,
    button: {
      textTransform: "none",
    },
  },
  components: {
    MuiDatePicker: {
      defaultProps: {
        inputFormat: DateConfig.FORMAT,
      },
    },
    MuiDesktopDatePicker: {
      defaultProps: {
        inputFormat: DateConfig.FORMAT,
      },
    },
    MuiMobileDatePicker: {
      defaultProps: {
        inputFormat: DateConfig.FORMAT,
      },
    },
    // MuiTabs: {
    //   defaultProps: {
    //     variant: "scrollable",
    //     scrollButtons: "auto",
    //     allowScrollButtonsMobile: true,
    //   },
    // },
    MuiTabs: {
      styleOverrides: {
        root: {
          padding: 10,
          minWidth: 10,
          marginRight: 30,
        },
      },
      defaultProps: {
        variant: "scrollable",
        scrollButtons: "auto",
        allowScrollButtonsMobile: true,
        sx: {
          typography: {
            fontSize: 12,
          },
        },
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0,
        style: {
          borderRadius: 16,
        },
      },
    },
    MuiLoadingButton: {
      defaultProps: {
        variant: "contained",
      },
      variants: [
        {
          props: { variant: "contained", color: "primary", opaque: true },
          style: { backgroundColor: "#d0e6f6" },
        },
        {
          props: { variant: "outlined", color: "primary", opaque: true },
          style: {
            backgroundColor: "#d0e6f6",
            ":hover": {
              backgroundColor: "#d0e6f6",
            },
          },
        },
        {
          props: { variant: "text", color: "primary", opaque: true },
          style: {
            backgroundColor: "#d0e6f6",
            paddingLeft: 15,
            paddingRight: 15,
            ":hover": {
              backgroundColor: "#d0e6f6",
            },
          },
        },
      ],
    },
    MuiButton: {
      defaultProps: {
        variant: "contained",
      },
      variants: [
        {
          props: { variant: "contained", color: "primary", opaque: true },
          style: { backgroundColor: "#d0e6f6" },
        },
        {
          props: { variant: "outlined", color: "primary", opaque: true },
          style: { backgroundColor: "#d0e6f6" },
        },
        {
          props: { variant: "text", color: "primary", opaque: true },
          style: {
            backgroundColor: "#d0e6f6",
            paddingLeft: 15,
            paddingRight: 15,
            ":hover": {
              backgroundColor: "#d0e6f6",
            },
          },
        },
      ],
    },
    MuiChip: {
      variants: [
        {
          props: { variant: "outlined-opaque", color: "primary" },
          style: {
            backgroundColor: "#d0e6f6",
          },
        },
        {
          props: { variant: "outlined-opaque", color: "success" },
          style: {
            backgroundColor: alpha(defaultTheme.palette.success.main, 0.1),
            color: defaultTheme.palette.success.main,
          },
        },
        {
          props: { variant: "outlined-opaque", color: "error" },
          style: {
            backgroundColor: alpha(defaultTheme.palette.error.main, 0.1),
            color: defaultTheme.palette.error.main,
          },
        },
        {
          props: { variant: "outlined-opaque", color: "warning" },
          style: {
            backgroundColor: alpha(defaultTheme.palette.warning.main, 0.1),
            color: defaultTheme.palette.warning.main,
          },
        },
        {
          props: { variant: "outlined-opaque", color: "info" },
          style: {
            backgroundColor: alpha(defaultTheme.palette.info.main, 0.1),
            color: defaultTheme.palette.info.main,
          },
        },
      ],
    },
  },
});

export default theme;

/**
 *
 * @param {import("@mui/material").Theme} theme
 */
function customizeComponents(theme) {
  return createTheme({
    ...theme,
  });
}

[
  "primary",
  "neutral",
  "success",
  "warning",
  "destructive",

  "secondary",
  "info",
  "error",
  "common",
  "text",
  "background",
  "action",
].forEach((palatteKey) => {
  Object.keys(theme.palette[palatteKey]).forEach((palatteKeyColor) => {
    document.documentElement.style.setProperty(
      `--color-${palatteKey}-${palatteKeyColor}`,
      theme.palette[palatteKey][palatteKeyColor]
    );
  });
});
